<div>
  <div class="table-header">
    <h3>{{ label }}</h3>
    <mat-form-field floatLabel="never" appearance="fill">
      <mat-icon aria-hidden="false" aria-label="search icon" matSuffix>
        search
      </mat-icon>
      <input matInput placeholder="Search" [(ngModel)]="searchText" (ngModelChange)="setData()">
    </mat-form-field>
  </div>
  <div style="max-height: calc(90vh - 380px); overflow-y: scroll; margin-bottom: 1%;">
    <table mat-table [dataSource]="datasource" class="mat-elevation-z1 full-width">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>Membership</th>
        <td mat-cell *matCellDef="let user">
          <mat-checkbox [(ngModel)]="user.selected" (change)="onSelectionChange()"></mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef>User Name</th>
        <td mat-cell *matCellDef="let user">{{ user.name }}</td>
      </ng-container>
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let user">{{ user.role || user.userRoleName }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
    </table>
  </div>
  <div>
    <div class="flex mat-paginator-sticky-modal mat-mdc-paginator-container-modal">
      <mat-paginator #paginator [length]="datasource?.data?.length" [pageIndex]="0" [pageSize]="10"
         appearance="fill" [pageSizeOptions]="[10, 25, 50, 100]">
      </mat-paginator>
    </div>
  </div>
  <div style="margin-bottom: 5%;">
    <mat-error *ngIf="showError">
      <small>At least one must be selected</small>
    </mat-error>
  </div>
</div>